module.exports = __webpack_public_path__ + "img/bdwp.a2554e8b.jpg";